import React from 'react';

const DifficultyLevelTable = (props) => {
    const studentResult = props.studentResult !== undefined && props.studentResult;
    const difficultyLevel = studentResult.difficulty !== undefined && studentResult.difficulty
    const easy = difficultyLevel[0] !== undefined && difficultyLevel[0]
    const medium = difficultyLevel[1] !== undefined && difficultyLevel[1]
    const tough   = difficultyLevel[2] !== undefined && difficultyLevel[2]


    let totalIncorrect = (easy.attempt_question - easy.correct_question) + (medium.attempt_question - medium.correct_question) + (tough.attempt_question - tough.correct_question)
    return (
        <>
        <div className='widget_title d-flex align-items-center justify-content-between'>
            <h3>Different Difficulty Levels</h3>
        </div>
        <div className='table-responsive difficulty_level_table'>
            <table className='table align-middle mb-0  table-sm'>
                <thead className='table-head-primary-light border-bottom-0'>
                    <tr>
                        <th>LEVEL</th>
                        <th>TOTAL QUESTIONS</th>
                        <th>Attempted</th>
                        <th>CORRECT</th>
                        <th>INCORRECT</th>
                        <th>LEFT</th>
                    </tr>
                </thead>
                <tbody className='border-top-0'>
                
                     <tr >
                     <td>Easy</td>
                     <td>{easy.total_question}</td>
                     <td>{easy.attempt_question}</td>
                     <td>{easy.correct_question}</td>
                     <td>{easy.attempt_question - easy.correct_question}</td>
                     <td>{parseInt(easy.total_question) - parseInt(easy.attempt_question)}</td> 
                 </tr>
                
                   
                    <tr>
                        <td>Moderate</td>
                        <td>{medium.total_question}</td>
                        <td>{medium.attempt_question}</td>
                        <td>{medium.correct_question}</td>
                        <td>{medium.attempt_question - medium.correct_question}</td>
                        <td>{parseInt(medium.total_question) - parseInt(medium.attempt_question)}</td> 
                    </tr>
                    <tr>
                        <td>Tough</td>
                        <td>{tough.total_question}</td>
                        <td>{tough.attempt_question}</td>
                        <td>{tough.correct_question}</td>
                        <td>{tough.attempt_question - tough.correct_question}</td>
                        <td>{parseInt(tough.total_question) - parseInt(tough.attempt_question)}</td>  
                    </tr>
                   
  
                </tbody>
                <tfoot className='table-light border-top'>
                <tr className='total_Cal_row'>
                        <td>Total</td>
                        <td>{parseInt(easy.total_question) + parseInt(medium.total_question) + parseInt(tough.total_question)}</td>
                        <td>{parseInt(easy.attempt_question) + parseInt(medium.attempt_question) + parseInt(tough.attempt_question)}</td>
                        <td>{parseInt(easy.correct_question) + parseInt(medium.correct_question) + parseInt(tough.correct_question)}</td>
                        <td>{totalIncorrect}</td>
                        <td>{(parseInt(easy.total_question) +  parseInt(medium.total_question) +  parseInt(tough.total_question)) - ( parseInt(easy.attempt_question) +  parseInt(medium.attempt_question) +  parseInt(tough.attempt_question))}</td>
                        
                        
                    </tr>
                </tfoot>
            </table>
        </div>
     
        </>
    );
}

export default DifficultyLevelTable